import axios from '../../shared/axiosConfig';
import { subToChatChannel } from  '../../channels/chat_channel'
import Push from 'push.js';

export const ChatActions = {
  SET_ATTRIBUTE: "CHAT_SET_ATTRIBUTE",
  ADD_MESSAGE: "CHAT_ADD_MESSAGE",
  SET_PEER: "CHAT_SET_PEER",
  SET_STATUS: "CHAT_SET_STATUS",
  RESET_STATE: "CHAT_RESET_STATE",
};

export const setChatAttribute = (key, value) => {
  return {
    type: ChatActions.SET_ATTRIBUTE,
    key,
    value
  };
};

export const chatResetState = () => {
  return {
    type: ChatActions.RESET_STATE
  }
}

export const addRemoteMessage = (message) => {
  return {
    type: ChatActions.ADD_MESSAGE,
    key: 'remote',
    value: message
  }
}

export const setPeer = (chatStorageKey, peer) => (dispatch) => {
  dispatch( {
    type: ChatActions.SET_PEER,
    key: chatStorageKey,
    value: (peer.uuid ? peer.uuid : peer)
  } );

  if(peer.profile) {
    dispatch( setChatAttribute( 'peerProfile', peer.profile ) );
  }
}

export const setStatus = (chatStorageKey, statusValue) => {
  return {
    type: ChatActions.SET_STATUS,
    key: chatStorageKey,
    value: statusValue
  }
}

export const setStatusTemp = (chatStorageKey, statusValue) => (dispatch) => {
  dispatch( setStatus(chatStorageKey, statusValue) );
  if( statusValue == 'typing' ) {
    setTimeout( () => {
      dispatch( setStatus(chatStorageKey, null) );
    }, 2000);
  }
}

export const sendStatus = (status) => (dispatch, getState) => {
  let lastStatusAt = getState().chat.lastStatusAt;
  if( Date.now() - lastStatusAt < 1000 ) return; // don't send more than 1 in a second
  let props = getState().company;
  let channel = getState().chat.channel;
  let chatStorageKey = `${props.eventId}:${props.companyId}`;
  let toPeer = getState().chat.peers[chatStorageKey];
  channel.sendStatus(toPeer, status);
  dispatch(setChatAttribute('lastStatusAt', Date.now()));
}

export const sendLocalMessage = (message) => (dispatch, getState) => {
  let props = getState().company;
  let channel = getState().chat.channel;
  let chatStorageKey = `${props.eventId}:${props.companyId}`;
  let toPeer = getState().chat.peers[chatStorageKey];
  let name = getState().profile.data.name;
  if( message != "" ) {
    // send message to socket
    channel.sendMessage(toPeer, message);
    let res = {
      type: ChatActions.ADD_MESSAGE,
      key: 'local',
      value: { chatStorageKey, message: { message: message, from: name } }
    }
    dispatch(res);
  }
}

// to add messages created before this session
export const addExistingMessage = (source, message) => (dispatch, getState) => {
  let props = getState().company;
  let chatStorageKey = `${props.eventId}:${props.companyId}`;
  let res = {
    type: ChatActions.ADD_MESSAGE,
    key: source,
    value: { chatStorageKey,  message }
  }
  dispatch(res);
}

const peerInfo = (getState) => {
  if( getState().chat.peerProfile ) {
    let peer = getState().chat.peerProfile;
    return {
      picture: peer.picture.thumb.url,
      name: `${peer.first_name} ${peer.last_name}`,
    }
  }
  return getState().peer.data;
}

export const endVideoChat = () => (dispatch, getState) => {
  let props = getState().company;
  let channel = getState().chat.channel;
  let chatStorageKey = `${props.eventId}:${props.companyId}`;
  let toPeer = getState().chat.peers[chatStorageKey];
  let name = getState().profile.data.name;
  let message = "/end_video_chat;"
  // send message to socket
  channel.sendMessage(toPeer, message);
  let res = {
    type: ChatActions.ADD_MESSAGE,
    key: 'local',
    value: { chatStorageKey, message: { message: message, from: name } }
  }
  dispatch(res);
  dispatch(setChatAttribute('videoChatData', {}));
  dispatch(setChatAttribute('videoChat', false));
  dispatch( setStatus( chatStorageKey, null) );
}



export const subToChat = (peer) => async (dispatch, getState) => {
  let alreadySubscribed = getState().chat.sub;
  let props = getState().company;
  if( peer ) props.peer = peer;
  if( ! alreadySubscribed ) {
    await subToChatChannel(props, (data) => {
      let chatStorageKey = `${props.eventId}:${props.companyId}`
      console.log("Incoming chat data", data);
      if(( ! peer ) || ( data.from && peer && data.from==peer )) {
        if( data.type == 'message' ) {
          if( data.payload.startsWith('/video_chat') ) {
            let con = data.payload.split(';')[1];
            dispatch(setChatAttribute('videoChatData', JSON.parse(con)));
            dispatch(setChatAttribute('videoChat', true));
            dispatch( setStatus( chatStorageKey, null) );
          }
          if( data.payload.startsWith('/end_video_chat') ) {
            let con = data.payload.split(';')[1];
            dispatch(setChatAttribute('videoChatData', {}));
            dispatch(setChatAttribute('videoChat', false));
            dispatch( setStatus( chatStorageKey, null) );
          }
          dispatch( setStatus( chatStorageKey, null) );
          setTimeout( () => {
            dispatch( addRemoteMessage({ chatStorageKey, message: { message: data.payload, from: data.from_name } }) );
            // show desktop notification
            if( Push.Permission.has() && (!data.payload.startsWith('/')) ) {
              let info = peerInfo(getState);
              Push.create(info.name, {
                body: data.payload,
                icon: info.picture || '/icons/message.png',
                timeout: 4000,
                onClick: function () {
                  window.focus();
                  this.close();
                }
              });
            }
          }, 500);
        }
        if( data.type == 'status' ) {
          console.log("New status", data.payload);
          dispatch( setStatusTemp( chatStorageKey, data.payload) );
        }
      }
      if( data.type == 'peer' ) {
        console.log("New peer", data.payload);
        dispatch( setPeer( chatStorageKey, data.payload) );
        dispatch( setChatAttribute( 'finished' , false ) );
        dispatch( loadChatMessages() );
      }
      if( data.type == 'disconnect' ) {
        console.log("Peer closed connection", data.payload);
        dispatch( setPeer( chatStorageKey, {} ) );
        dispatch( setChatAttribute( 'finished' , true ) );
        dispatch( setChatAttribute( 'peerProfile', null ) );
      }
    }, (channel) => {
      dispatch( setChatAttribute('channel', channel) );
    });
    console.log("Subscribed to chat");
    setTimeout( () => {
      dispatch(reconnect()) }, 500 ); // notify peer
  }
  dispatch(setChatAttribute('sub', true));
}

export const enablePush = () => (dispatch) => {
  Push.Permission.request(() => {
    dispatch( setChatAttribute('push', true) );
  }, () => {
    dispatch( setChatAttribute('push', false) );
  });
}

export const reconnect = () => (dispatch, getState) => {
  let channel = getState().chat.channel;
  channel.reconnect();
}

export const leaveChat = () => (dispatch, getState) => {
  let alreadySubscribed = getState().chat.sub;
  let channel = getState().chat.channel;
  if( alreadySubscribed ) {
    channel.leave();
    console.log("Left chat");
  }
  dispatch(setChatAttribute('videoChat', false));
  dispatch(setChatAttribute('videoChatUrl', null));
  dispatch(setChatAttribute('sub', false));
  dispatch(setChatAttribute('finished', false));
  dispatch( setChatAttribute( 'peerProfile', null ) );
}


export const loadChatMessages = () => async (dispatch, getState) => {
  let { eventId, companyId } = getState().company;
  let peerId = getState().profile.data.uuid;

  if( Object.keys(getState().chat.messages).length > 0 ) return; // only if empty

  await axios.get(`/api/events/${eventId}/companies/${companyId}/chat_messages`)
    .then((response) => {
      console.log("Got existing chat messages", response.data);
      for(let i = 0; i< response.data.length; i++) {
        let message = response.data[i];
        let source = message.from_peer != peerId ? 'remote' : 'local';
        dispatch(addExistingMessage( source, message, peerId ));
      }
    })
    .catch((error) => {
      console.log("Error loading peer data", error);
    })
}
